import React, { Component } from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { isMobile } from 'react-device-detect';
import Radio from '@components/Radio';
import { default as ModalDefault } from '@components/Modal';
import { cpm, cpv } from '@utils/businessRule';
import { handleNewEventMixPanel } from '@utils/helpers';
import { withRouter } from 'react-router';
import { LoadingOld } from '@components/LoadingOld/LoadingOld';

const RadioWrapper = styled('div')`
  padding: 15px;
  color: #0a3b5b;
  font-size: 15px;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const IframeWrapper = styled('div')`
  text-align: center;
  width: 100%;
  iframe {
    height: 100%;
  }
  @media screen and (max-width: 600px) {
    overflow: hidden;
  }
`;

const CustomIframe = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60vh;
  box-sizing: border-box;
  padding: 0 15px;
`;

const AdsDetails = styled('div')`
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px 15px;
`;

const AdsDetailsItem = styled('div')`
  ${({ theme }) => `
        flex-basis: ${theme.spacing.middle};
        
        font-size: ${theme.fontSize.px16};
        color: ${theme.colors.blueGrey2};
        padding-bottom: ${theme.spacing.px10};
        text-align: center;
        strong {
            font-size: ${theme.fontSize.px14};
        }
    `}
`;

const LinkStyled = styled('p')`
  ${({ theme }) => `
        color: ${theme.colors.blue2};
        text-decoration: underline;
    `}
`;

class PreviewModal extends Component {
  constructor(props) {
    super(props);

    this.fieldRadioMobile = React.createRef();
    this.clickFieldRadioMobile = this.clickFieldRadioMobile.bind(this);
  }

  state = {
    previewType: 'DESKTOP',
    selectedPreview: null,
    previews: {},
  };

  componentDidUpdate(prevProps) {
    const {
      state,
      props: {
        media,
        showPreviewModal,
        feedReducer: { previews },
      },
    } = this;

    if (
      !isEqual(prevProps.feedReducer.previews, previews) &&
      !previews.isLoading &&
      previews.data.length > 0 &&
      media.id === previews.data[0].id &&
      !state.selectedPreview
    ) {
      this.openModal(previews.data[0].previews);
    }

    if (prevProps.showPreviewModal !== showPreviewModal && showPreviewModal) {
      if (isMobile) {
        setTimeout(() => {
          this.clickFieldRadioMobile();
        });
      }
    }
  }

  clickFieldRadioMobile() {
    this.fieldRadioMobile && this.fieldRadioMobile.current && this.fieldRadioMobile.current.click();
  }

  openModal = (previews) => {
    const { state } = this;

    let selectedPreview;

    if (state.previewType === 'DESKTOP') {
      selectedPreview = previews.desktop;
      handleNewEventMixPanel(
        'click_preview_desktop_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    } else if (state.previewType === 'MOBILE') {
      selectedPreview = previews.mobile;
      handleNewEventMixPanel(
        'click_preview_mobile_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    } else if (state.previewType === 'STORIES') {
      selectedPreview = previews.instagram_stories;
      handleNewEventMixPanel(
        'click_preview_stories_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    }

    this.setState({
      previews,
      selectedPreview,
    });
  };

  closeModal = () => {
    const {
      props: { closeModal },
    } = this;
    this.setState({
      selectedPreview: null,
    });
    closeModal();
  };

  iframe = () => ({ __html: this.state.selectedPreview });

  setPreviewType = (event) => {
    const { state } = this;

    let selectedPreview;

    if (event.target.value === 'DESKTOP') {
      selectedPreview = state.previews.desktop;
      handleNewEventMixPanel(
        'click_preview_desktop_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    } else if (event.target.value === 'MOBILE') {
      selectedPreview = state.previews.mobile;
      handleNewEventMixPanel(
        'click_preview_mobile_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    } else if (event.target.value === 'STORIES') {
      selectedPreview = state.previews.instagram_stories;
      handleNewEventMixPanel(
        'click_preview_stories_feed_web_button',
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    }

    this.setState({
      previewType: event.target.value,
      selectedPreview,
    });
  };

  render() {
    const {
      props: {
        text,
        feedType,
        clickOnText,
        showPreviewModal,
        media,
        feedReducer: { data, feedOrderBy, previews },
      },
    } = this;

    const previewId = previews && previews.data && previews.data[0] ? previews.data[0].id : null;
    const itemSelected = data.find((x) => x.id === previewId);

    return (
      <>
        {text && <LinkStyled onClick={clickOnText}>{text}</LinkStyled>}
        {showPreviewModal && showPreviewModal === media.id && (
          <ModalDefault
            visible
            effect="fadeInDown"
            width={600}
            onClickAway={this.closeModal}
            title="Preview"
            iconClose={['fal', 'times']}
          >
            <RadioWrapper onChange={this.setPreviewType.bind(this)}>
              <Radio id="desktop" value="DESKTOP" name="type" text="Desktop" defaultChecked />
              <Radio
                id="mobile"
                value="MOBILE"
                name="type"
                text="Mobile"
                innerRef={this.fieldRadioMobile}
              />
              <Radio id="stories" value="STORIES" name="type" text="Stories" />
            </RadioWrapper>
            <IframeWrapper>
              {previews.isLoading ? (
                <LoadingOld isLoading centerIcon />
              ) : (
                <>
                  {itemSelected &&
                    itemSelected.insights &&
                    feedType === 'AD' &&
                    (feedOrderBy === 'video_view' || feedOrderBy === 'post_engagement') && (
                      <AdsDetails>
                        {!!itemSelected.insights.post_engagement && (
                          <AdsDetailsItem>
                            <strong>Engagements:</strong>{' '}
                            {numeral(itemSelected.insights.post_engagement).format('0,0')}
                          </AdsDetailsItem>
                        )}
                        {!!itemSelected.insights.video_view && (
                          <AdsDetailsItem>
                            <strong>Video views:</strong>{' '}
                            {numeral(itemSelected.insights.video_view).format('0,0')}
                          </AdsDetailsItem>
                        )}
                        {!!itemSelected.insights.impressions && (
                          <AdsDetailsItem>
                            <strong>Impressions:</strong>{' '}
                            {numeral(itemSelected.insights.impressions).format('0,0')}
                          </AdsDetailsItem>
                        )}
                        {!!itemSelected.reach && (
                          <AdsDetailsItem>
                            <strong>Reach:</strong> {numeral(itemSelected.reach).format('0,0')}
                          </AdsDetailsItem>
                        )}
                        {!!itemSelected.insights.spend && (
                          <AdsDetailsItem>
                            <strong>Spend:</strong>{' '}
                            {numeral(itemSelected.insights.spend).format('$ 0,0.00')}
                          </AdsDetailsItem>
                        )}
                        {itemSelected.insights.spend && itemSelected.insights.impressions && (
                          <AdsDetailsItem>
                            <strong>CPM:</strong>{' '}
                            {numeral(
                              cpm(itemSelected.insights.spend, itemSelected.insights.impressions)
                            ).format('0.000')}
                          </AdsDetailsItem>
                        )}
                        {itemSelected.insights.spend && itemSelected.insights.video_view && (
                          <AdsDetailsItem>
                            <strong>CPV:</strong>{' '}
                            {numeral(
                              cpv(itemSelected.insights.spend, itemSelected.insights.video_view)
                            ).format('0.000')}
                          </AdsDetailsItem>
                        )}
                      </AdsDetails>
                    )}
                  <CustomIframe dangerouslySetInnerHTML={this.iframe()} />
                </>
              )}
            </IframeWrapper>
          </ModalDefault>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedReducer: state.feedReducer,
    authenticationReducer: state.authenticationReducer,
  };
}

export default withRouter(connect(mapStateToProps)(PreviewModal));
